(function(){
	loadStyle('./css/footnotes.css');

	var footnote_alert_text = '⚠️ Please note that this selection contains important footnotes regarding the data provided. Click the footnotes link at the bottom right for details.';

	function popupwindow(url, title, w, h) {
  	if(typeof this.win !== 'undefined' && !this.win.closed) {
    	this.win.focus();
    	return this.win;
  	}
		var left = (screen.width/2)-(w/2);
		var top = (screen.height/2)-(h/2);
		this.win = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
		$(window).on('beforeunload', function(){
  		win.close();
		});

		return this.win;
	}

	var country_codes = _.map(statCompilerDashboard.getSelectedCountryCodes(), 'name');
	var attempts = 0;
  var interval = setInterval(function(){
    country_codes = _.map(statCompilerDashboard.getSelectedCountryCodes(), 'name');
    attempts++;
    if(country_codes.length || attempts > 300){
      // clearInterval(interval);
      show_footnotes(country_codes);
    }
  }, 2000);

var current_country_codes = null;
function show_footnotes(country_codes){
  if(_.isEqual(country_codes, current_country_codes)) return;
  current_country_codes = country_codes;
  if(country_codes.indexOf('PK') === -1) {
    $('.footnote_alert, .footnote_button').remove();
    return;
  }
  $.getJSON(window.DHS_API_ENDPOINT+'surveys/PK?returnFields=SurveyYear,Footnotes,SurveyYearLabel', function(data){

    var recent_survey = _.sortBy(data.Data, 'SurveyYear').slice(-1);
    var notes = _.reduce(recent_survey, function(result, value, key){

      if(value.Footnotes){
		recent_survey = recent_survey.length ? recent_survey[0] : {};
        if(recent_survey.SurveyYear > 2016){
          result.push('Year - ' + value.SurveyYearLabel+ ': ' + value.Footnotes);
        }
        else if(window.DHS_API_ENDPOINT.indexOf('preview') > -1){
          result.push('Year - ' + value.SurveyYearLabel+ ': ' + value.Footnotes);
          result.push('NOTE: The above information is only displayed because the site is in preview mode. Otherwise, footnotes from earlier than 2017 are not displayed');
        }
      }
      return result;
    }, []);
    var notes_markup = '<h3>Pakistan</h3><ol><li>' + notes.join('</li><li>') + '</li></ol>';

    if(!notes.length) return;
    if(!$('.footnote_button').length){
        var button = $('<button id="sliderButtonXXX" class="ccclast footnote_button" style="margin-left:auto; border: 2px solid #ba0c2f; border-radius: 3px; ">Footnotes</button>');
        button.on('click', function(){
          console.log(notes_markup)
          var win = popupwindow('./js/popup.html', 'Footnotes', 600, 450);
          $(win).on('load', function(){
            $(win.document.body).find('#inject_footnote').html(notes_markup);
          });
        });
        $('.toolbarButtonContainer').append(button);
    }


   if(!$('.footnote_alert').length && !!!sessionStorage.pakistan_footnote_seen){
        var $alert = $('<div class="alert alert-danger footnote_alert">'+footnote_alert_text+'</div>');
        $alert.append('<a class="close" onclick="sessionStorage.pakistan_footnote_seen=true; this.parentNode.remove()"></a>').css({
          position: 'fixed',
          zIndex: 999999,
          top: 0, left: 0, right: 0,
        }).appendTo(document.body);
    }

  });


}


})()
